// @ts-ignore
import userStore from '@/stores/user/index';

// 获取 是否使用 user type  缓存的实验组
const getUserTypeRetentionExperiment = () => {
  return (userStore.newABTestingConfigs as any)?.User_Type_Retention === 'with_user_type_retention';
};

export default getUserTypeRetentionExperiment;
